// KK ekranındaki köken bandı — Geçmiş Rapor Aktarımı (Task 15, 10A/13A).
//
// Aktif bölümün metni rapordan aktarıldıysa editörün üstünde tek satır:
//   "📄 Rapordan aktarıldı · s.44 · yeniden yazılmadı"   (reviewBand)
//   "📄 Rapordan aktarıldı · s.44 · sonradan düzenlendi" (reviewBandEdited)
// Ayrım YALNIZ zaman damgasıyla (10A/G3): `sectionUpdatedAt > finishedAt + 2 s`.
//
// Stil: coverage bandının kardeşi ama NÖTR (`--color-bg` + `--color-border`) —
// aktarım bir uyarı değil, köken bilgisidir; amber/kırmızı token kullanılmaz.
// D13 — bu bileşen `<select>` İÇERMEZ (`qc-flow.spec.ts:34` Review'daki select
// sayısını sayıyor; bandın select eklemesi o testi sessizce kırardı).

import type { ProjectProvenanceResponse } from "@mahir/shared";
import { fillTemplate } from "../../lib/period-ui";
import { IMPORT_COPY, isEditedAfterImport, latestCreateImport } from "../../lib/report-import-ui";

export interface ProvenanceBandProps {
  provenance: ProjectProvenanceResponse | null;
  /** Aktif bölümün kodu — `provenance.sections` içinde yoksa bant çizilmez. */
  sectionCode: string | null;
}

export function ProvenanceBand(props: ProvenanceBandProps): JSX.Element | null {
  const { provenance, sectionCode } = props;
  if (!provenance || !sectionCode) return null;
  const record = provenance.sections.find((s) => s.sectionCode === sectionCode);
  if (!record) return null;

  const createImport = latestCreateImport(provenance.imports);
  const ref =
    record.sourcePages && record.sourcePages.length > 0
      ? fillTemplate(IMPORT_COPY.badgePage, { page: record.sourcePages[0]! })
      : (record.sourceLocator ?? "—");

  const edited =
    record.sectionUpdatedAt !== null &&
    createImport?.finishedAt != null &&
    isEditedAfterImport(record.sectionUpdatedAt, createImport.finishedAt);

  return (
    <div
      className="mb-3 rounded-md p-2"
      style={{
        background: "var(--color-bg)",
        border: "1px solid var(--color-border)",
        fontSize: "0.78rem",
        color: "var(--color-text-2)",
      }}
    >
      {fillTemplate(edited ? IMPORT_COPY.reviewBandEdited : IMPORT_COPY.reviewBand, { ref })}
    </div>
  );
}
